import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useRequireUser } from '../hooks/useRequireUser';
import { UsuarioUtils } from '../model/Usuario/Usuario';
import { Perfil } from '../model/Usuario/Perfil';
import { Spinner } from 'react-bootstrap';

interface RouteGuardProps {
    routeTo: JSX.Element;
    requiredPermissoes: string[];
    requiredPerfis: Perfil[];
    isBancaIdRequired?: boolean;
    isProcessoIdRequired?: boolean;
}

const RouteGuard: React.FC<RouteGuardProps> = ({ routeTo, requiredPermissoes, isBancaIdRequired, isProcessoIdRequired, requiredPerfis }) => {
    const { user, userLoading, isReady } = useRequireUser();
    const { processoId } = useParams<{ processoId: string }>();
    const { bancaId } = useParams<{ bancaId: string }>();

    // Loading state unificado - SEMPRE aguarda inicialização completa
    if (userLoading || !isReady) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                <Spinner animation="border" />
            </div>
        );
    }

    // Se não há usuário, deixa o useRequireAuth lidar com o redirecionamento
    if (!user) {
        return null;
    }

    // Se não precisa de permissões específicas, só precisa estar autenticado
    if (requiredPermissoes.length === 0 && requiredPerfis.length === 0) {
        return routeTo;
    }

    let requiredId: string | null = null
    if(isBancaIdRequired) requiredId = bancaId || null
    if(isProcessoIdRequired) requiredId = processoId || null

    // Verifica permissões
    const permissoesToCheck = requiredId 
        ? requiredPermissoes.map(p => `${p}-${requiredId}`)
        : requiredPermissoes;
    
    const hasRequiredPermissoes = UsuarioUtils.verificarTodasPermissoes(user, permissoesToCheck);
    const hasRequiredPerfil = UsuarioUtils.verificarPerfilUsuario(user, requiredPerfis);
    
    return (hasRequiredPermissoes && hasRequiredPerfil) ? routeTo : <Navigate to="/acesso-negado" />;
};

export default RouteGuard;
